module.exports = __webpack_public_path__ + "1c1f7036.png";